import React from 'react';
import { ThemeContextValue } from '@weave-design/theme-context';
import { INFO360_THEMES } from '../theme.types';
import { weaveThemes } from '../weave.types';

interface WeaveThemeContextProps {
	theme: INFO360_THEMES;
	setTheme: (newTheme: INFO360_THEMES) => void;
	displayThemePicker: boolean;
	weaveThemeConsumer: ThemeContextValue;
	setWeaveThemeConsumer: React.Dispatch<
		React.SetStateAction<ThemeContextValue>
	>;
	isWeaveTheme?: boolean;
}

export const WeaveThemeContext = React.createContext<WeaveThemeContextProps>({
	theme: INFO360_THEMES.Classic,
	setTheme: () => {},
	displayThemePicker: false,
	weaveThemeConsumer: weaveThemes[INFO360_THEMES.Classic],
	setWeaveThemeConsumer: () => {},
});

export const useWeaveThemeContext = () => {
	const context = React.useContext(WeaveThemeContext);
	if (!context) {
		throw new Error('useWeaveThemeContext must be used within a Provider');
	}
	return context;
};
